import type { UseDocumentProps } from '@ztechapps/common.hook'
import { useDocument } from '@ztechapps/common.hook'
import type { Order } from '@ztechapps/common.contract'
import { singleOrderQuery } from './graphql'

export const useOrderDocument = (props: Partial<UseDocumentProps>) => {
  return useDocument<Order>({
    query: singleOrderQuery,
    ...props,
  })
}
